import React from "react";
import "./section.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { toggleCheck } from "../../../store/slices/afe_checkList.sllices";
import { AFE_CHECKLIST } from "../../data/afe_data";

const AFECheckList = () => {
  const dispatch = useDispatch();

  // flat state like { a: false, b: false, c: false, d: true }
  const checks = useSelector((state) => state.afe_list);

  return (
    <Box className="arrayFramingSec">
      <Typography variant="h6" gutterBottom fontWeight="bold">
        Table 2: Array Frame Earthing
      </Typography>

      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell width="50%" sx={{ fontWeight: "bold" }}>
                Question
              </TableCell>
              <TableCell width="40%" sx={{ fontWeight: "bold" }}>
                Instruction / Details
              </TableCell>
              <TableCell width="10%" align="center" sx={{ fontWeight: "bold" }}>
                Confirm
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {AFE_CHECKLIST.map((row) => (
              <TableRow key={row.key}>
                <TableCell sx={{ verticalAlign: "top" }}>
                  {row.question}
                </TableCell>

                <TableCell sx={{ verticalAlign: "top" }}>
                  <Typography variant="subtitle2" fontWeight="bold">
                    {row.instruction}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {row.details}
                  </Typography>
                </TableCell>

                <TableCell align="center">
                  <Checkbox
                    checked={checks[row.key]}
                    onChange={() => dispatch(toggleCheck(row.key))}
                    color="primary"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mt: 2 }}>
        <Typography variant="body2">
          <strong>Tick</strong> to confirm if a, b, c or d apply and complete
          relevant earthing.
        </Typography>
        <Typography variant="body2">
          Apply the most onerous requirements if more than one condition in this
          table applies.
        </Typography>
      </Box>
    </Box>
  );
};

export default AFECheckList;
